/* eslint-disable no-console */
import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import {
  fetchCity83431FromFirestore,
  fetchPartnerBannerFromFirestore,
  listenToPartnerFromFirestore,
} from "../../../firestore/firestoreService";
import { useFirestoreCollection } from "../../../hooks/useFirestoreCollection";
import { Footer, HotelSearchBox, Loader } from "../../molecules";
import { userFirestoreDoc } from "../../../hooks/useFirestoreDoc";
import { IPartner, IPartnerBanner } from "../../../common/types";
import { HotelHomeWrapper } from "./HotelHome.style";
const partnerId = process.env.REACT_APP_SITE_ID || "POUPAS";
export const HotelHome: React.FC = () => {
  const dispatch = useDispatch();
  const [cities, setCities] = React.useState([]);
  const [localLoading, setLoading] = React.useState(false);
  const isMobile = useMediaQuery({ query: "(max-width: 700px)" });
  const [partner, setPartner] = React.useState<IPartner>();
  const [banners, setBanners] = React.useState<IPartnerBanner[]>([]);
  userFirestoreDoc({
    query: () => listenToPartnerFromFirestore(partnerId),
    data: setPartner,
    shouldExecute: !!partnerId,
    deps: [dispatch, partnerId],
    local: true,
    localSetLoader: setLoading,
  });
  useFirestoreCollection({
    query: () =>
      fetchPartnerBannerFromFirestore(partnerId, [
        {
          type: "filter",
          name: "display",
          opr: "==",
          value: "HOTEL_PAGE",
        },
      ]),
    data: setBanners,
    shouldExecute: !!partnerId,
    local: true,
    deps: [dispatch, partnerId],
  });
  useFirestoreCollection({
    query: () =>
      fetchCity83431FromFirestore([
        {
          type: "filter",
          name: "countryCode",
          opr: "==",
          value: "CY",
        },
      ]),
    data: setCities,
    local: true,
    deps: [dispatch],
  });
  if (localLoading) return <Loader color="#fff" />;

  const defaultSections: IPartnerBanner[] = [] as unknown as IPartnerBanner[];

  const sections = banners?.length ? banners : defaultSections;
  return (
    <HotelHomeWrapper className="hotel-home">
      <div className="scroll-full">
        <section className="hotel-hero">
          <div className="hotel-hero__content">
            <h1
              className="hotel-hero__title"
              style={{
                color: isMobile
                  ? "#fff"
                  : partner?.hotelHeaderTitleColor || "#fff",
              }}
            >
              {partner?.hotelHeaderTitle ||
                "Προσφορές σε ξενοδοχεία στη Κύπρο!"}
            </h1>
            <div className="hotel-hero__search">
              <HotelSearchBox cities={cities} />
            </div>
          </div>
        </section>

        <div className="hotel-main">
          {sections?.map((banner) => (
            <section className="section hotel-section" key={banner.id}>
              <div className="section-heading">
                <h2 className="blue-color">{banner.title}</h2>
                {banner.subtitle && (
                  <div className="subtitle">{banner.subtitle}</div>
                )}
              </div>
              <div className="gallery-grid">
                {banner?.banners?.map((bannerImage) => (
                  <Link
                    to={bannerImage.url || ""}
                    className="gallery-card"
                    key={bannerImage.id}
                  >
                    <img
                      src={bannerImage.image?.[0]?.url || ""}
                      alt={bannerImage?.title || ""}
                    />
                    <div className="gallery-card__overlay">
                      <div className="gallery-card__label">
                        {bannerImage?.title || banner.title}
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>
        <Footer isMobile={isMobile} />
      </div>
    </HotelHomeWrapper>
  );
};
